const modalAlertaInitialState = {
    modalAlerta: {
        show: false,
        data: {
            type: null,
            text: null,
            accion: null,
            bloquearDismiss: null
        }
    },
};

export default modalAlertaInitialState;